import { cn } from '@/lib/utils';
import { LogoImg } from '@/components/ui/logo-img';

export function OrgInitial({
  name,
  logoKey,
  className,
}: {
  name: string;
  logoKey?: string | undefined;
  className?: string | undefined;
}) {
  if (logoKey) {
    return (
      <span
        aria-hidden="true"
        className={cn(
          'inline-flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-lg',
          className,
        )}
      >
        <LogoImg objectKey={logoKey} size="small" className="h-full w-full object-contain" />
      </span>
    );
  }

  const letter = (name.trim()[0] ?? '?').toUpperCase();
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ink text-primary font-heading font-extrabold text-base',
        className,
      )}
    >
      {letter}
    </span>
  );
}
